export { default as useProductColors } from './useProductColors';
